import React, { useCallback } from 'react';
import { useMutation } from '@apollo/client';

export default function withModifyMutation (WrappedComponent) {
	const ReturnedComponent = (props) => {
		const {
			modifyMutation, // The GraphQL document
		} = props;

		const [mutationFunction, mutationStatus] = useMutation(modifyMutation);

		const modifyItem = useCallback(async (values) => {
			return mutationFunction({
				variables: {
					input: values,
				},
			});
		}, [mutationFunction]);


		return (
			<WrappedComponent
				modifyItem={modifyItem}
				modifyItemStatus={mutationStatus}
				{...props}
			/>
		);
	};

	return ReturnedComponent;
}

